import axios from 'axios'
import { saveAs } from 'file-saver'

export const ADMIN_ACCOUNT = 'admin'

export async function readAdminActionError(error) {
	const response = error.response
	if (!response) return error.message

	const data = response.data
	if (data && typeof data.text === 'function') {
		const text = await data.text()
		try {
			const parsed = JSON.parse(text)
			return parsed.msg || parsed.message || text
		} catch (parseError) {
			return text || error.message
		}
	}

	return data && (data.msg || data.message)
		? data.msg || data.message
		: error.message
}

function getFilenameFromDisposition(disposition) {
	if (!disposition) return null

	const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
	if (utf8Match) {
		try {
			return decodeURIComponent(utf8Match[1])
		} catch (error) {
			return utf8Match[1]
		}
	}

	const plainMatch = disposition.match(/filename="?([^";]+)"?/i)
	return plainMatch ? plainMatch[1] : null
}

export function isBatchDownloadRouteMissing(message) {
	return !message || /Cannot POST|<!doctype|<html/i.test(message)
}

export async function requestAgreementRecalculation(psgFileId) {
	const response = await axios.post('/recalculate_agreement', { psgFileId })
	return response.data
}

export async function saveBatchWorkshopReports(psgFileId, scoringTimes) {
	const response = await axios.post('/batch_workshop_reports', {
		psgFileId,
		scoringTimes
	}, {
		responseType: 'blob'
	})
	const filename = getFilenameFromDisposition(response.headers['content-disposition']) ||
		`workshop_reports_psg${psgFileId}_time${scoringTimes}.zip`
	saveAs(response.data, filename)
}
